(function () {
  'use strict';

  function initCarousel(section) {
    if (!section || section.dataset.rouxMediaCarouselV2Ready === 'true') return;
    section.dataset.rouxMediaCarouselV2Ready = 'true';

    var slides = Array.from(section.querySelectorAll('[data-rmc-slide]'));
    var dots = Array.from(section.querySelectorAll('[data-rmc-dot]'));
    var audienceButtons = Array.from(section.querySelectorAll('[data-rmc-audience-button]'));
    var prev = section.querySelector('[data-rmc-prev]');
    var next = section.querySelector('[data-rmc-next]');
    var track = section.querySelector('[data-rmc-track]');
    var audience = section.dataset.defaultAudience || 'men';
    var index = 0;
    var autoplay = section.dataset.autoplay === 'true';
    var autoplaySeconds = Math.max(3, Number(section.dataset.autoplaySeconds || 6));
    var timer = null;
    var touchStartX = null;

    if (!slides.length) return;

    function slidesForAudience(value) {
      return slides.filter(function (slide) {
        return slide.dataset.audience === value;
      });
    }

    function dotsForAudience(value) {
      return dots.filter(function (dot) {
        return dot.dataset.audience === value;
      });
    }

    function availableAudience(value) {
      return slidesForAudience(value).length > 0;
    }

    function normalizeAudience(value) {
      if (availableAudience(value)) return value;
      if (availableAudience('men')) return 'men';
      if (availableAudience('women')) return 'women';
      return value;
    }

    function activeSlides() {
      return slidesForAudience(audience);
    }

    function activeDots() {
      return dotsForAudience(audience);
    }

    function pauseInactiveVideos() {
      slides.forEach(function (slide) {
        var isActive = slide.classList.contains('is-active');
        slide.querySelectorAll('video').forEach(function (video) {
          if (isActive) {
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } else {
            try { video.pause(); } catch (error) {}
          }
        });
      });
    }

    function syncAudienceButtons() {
      audienceButtons.forEach(function (button) {
        var value = button.dataset.rmcAudienceButton;
        var active = value === audience;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function syncDots() {
      var groupDots = activeDots();

      dots.forEach(function (dot) {
        dot.hidden = dot.dataset.audience !== audience;
        dot.classList.remove('is-active');
        dot.setAttribute('aria-pressed', 'false');
      });

      if (groupDots[index]) {
        groupDots[index].classList.add('is-active');
        groupDots[index].setAttribute('aria-pressed', 'true');
      }
    }

    function syncArrows() {
      var show = activeSlides().length > 1;
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
    }

    function showSlide(nextIndex) {
      var groupSlides = activeSlides();
      if (!groupSlides.length) return;

      index = (nextIndex + groupSlides.length) % groupSlides.length;

      slides.forEach(function (slide) {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
      });

      groupSlides[index].classList.add('is-active');
      groupSlides[index].setAttribute('aria-hidden', 'false');

      syncAudienceButtons();
      syncDots();
      syncArrows();
      pauseInactiveVideos();
    }

    function setAudience(nextAudience) {
      audience = normalizeAudience(nextAudience);
      index = 0;
      showSlide(0);
      restartTimer();
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplay || activeSlides().length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      timer = window.setInterval(function () {
        showSlide(index + 1);
      }, autoplaySeconds * 1000);
    }

    function restartTimer() {
      if (!autoplay) return;
      startTimer();
    }

    audienceButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        setAudience(button.dataset.rmcAudienceButton || 'men');
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        showSlide(index - 1);
        restartTimer();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(index + 1);
        restartTimer();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (dot.dataset.audience !== audience) return;
        var groupDots = activeDots();
        var dotIndex = groupDots.indexOf(dot);
        if (dotIndex < 0) return;
        showSlide(dotIndex);
        restartTimer();
      });
    });

    if (track) {
      track.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;

        var diff = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(diff) < 42) return;

        showSlide(index + (diff < 0 ? 1 : -1));
        restartTimer();
      }, { passive: true });

      track.addEventListener('mouseenter', stopTimer);
      track.addEventListener('mouseleave', startTimer);
      track.addEventListener('focusin', stopTimer);
      track.addEventListener('focusout', startTimer);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer();
      else startTimer();
    });

    audience = normalizeAudience(audience);
    showSlide(0);
    startTimer();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-media-carousel-v2]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
